<muni-gameday-tabbed-panel
  [condensed]="true"
  data-automation-e2e-selector="top_managers_accounts_card"
  [linkText]="(reportLinkVisible | async) ? 'Reports' : null"
  [linkUrl]="reportsLink"
  (changed)="onChange($event)"
  [subscribeOnChange]="false"
  [reactOnChange]="true"
  #tabs
>
  <muni-gameday-tab
    header="Top Accounts"
    data-automation-e2e-selector="top_accounts_table_body"
  >
    <muni-gameday-top-orders-table
      [orderAmounts]="topOrdersByAccounts | async"
      [emptyMessage]="accountsEmptyMessage | async"
    >
    </muni-gameday-top-orders-table>
  </muni-gameday-tab>
  <muni-gameday-tab
    header="Top Managers"
    data-automation-e2e-selector="top_managers_table_body"
  >
    <muni-gameday-top-orders-table
      [orderAmounts]="topOrdersByManagers | async"
      [emptyMessage]="managersEmptyMessage | async"
    >
    </muni-gameday-top-orders-table>
  </muni-gameday-tab>
</muni-gameday-tabbed-panel>
